import React, { Component, PropTypes } from 'react';

class AnalysisMeteorologicalHeatIndex extends Component {
  render() {
    return (
      <div>AnalysisMeteorologicalHeatIndex</div>
    );
  }
}

export default AnalysisMeteorologicalHeatIndex;



// WEBPACK FOOTER //
// ./src/components/Analysis/Meteorological/HeatIndex.js